import React, { useMemo } from 'react';
import { Button } from '@osui/ui';
import classNames from 'classnames';
import { IconDownload, IconRefresh, IconSetting, IconAddSolid } from './Icon';
import './index.less';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionButton = /*#__PURE__*/React.forwardRef(({
  action,
  className,
  ...props
}, ref) => {
  const iconNode = useMemo(() => {
    switch (action) {
      case 'create':
        return /*#__PURE__*/_jsx(IconAddSolid, {
          className: 'icloud-ui-action-button-icon icon-create'
        });

      case 'refresh':
        return /*#__PURE__*/_jsx(IconRefresh, {
          className: 'icloud-ui-action-button-icon'
        });

      case 'download':
        return /*#__PURE__*/_jsx(IconDownload, {
          className: 'icloud-ui-action-button-icon'
        });

      case 'customNav':
        return /*#__PURE__*/_jsx(IconSetting, {
          className: 'icloud-ui-action-button-icon'
        });
    }
  }, [action]);
  return /*#__PURE__*/_jsx(Button, {
    flexCenter: true,
    ref: ref,
    icon: iconNode,
    className: classNames(className, 'icloud-ui-action-button-wrap'),
    ...props
  });
});
export default ActionButton;
//# sourceMappingURL=es/index.js.map